import * as R from 'ramda'
import depreciation from './depreciation'
import incomeStatement from './incomeStatement'

export default (transactions, properties, leases, listings, taxBraket, startMarketDateByPropertyID, period) => {
	let currDepreciation = depreciation(properties, startMarketDateByPropertyID, period)
	let expenses = incomeStatement(transactions, properties, leases, listings, startMarketDateByPropertyID, period).expenses
	let res = R.map(property => {
		let repair = (R.find(x => x.category == "Repair")(expenses[property._id].categories) || {amount: 0}).amount
		let cleaning = (R.find(x => x.category == "Cleaning")(expenses[property._id].categories)|| {amount: 0}).amount
		let depreciation = currDepreciation[property._id]
		return (depreciation + repair + cleaning) * taxBraket / 100
	})(properties)
	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0))(res)
	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/taxDeferal.js